export const actionOptions = {
  "actions": [
    {
      title: "Upload Photos",
      cls: "upload-photos",
      icon: "hourglass",
      disabled:false
    },
	    {
      title: "Edit Record",
      cls: "edit-discrepancy",
      icon: "pencil",
      disabled:false
    },
	    {
      title: "Delete Record",
      cls: "delete-record",
      icon: "pencil",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/receivingDiscrepancies/filter/actionOptions.js